import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  getAccountInfo,
  selectAccountInfo,
} from "../../../state/ducks/member/index";
import EminevimLoading from "../shared/EminevimLoading";
import LoginPageAlert from "../Login/LoginPageAlert";

class AccountInfo extends Component {
  state = {
    isLoading: true,
    shouldAnimateCard: false,
    profileAlert: null,
  };

  componentDidMount() {
    const profileAlert = this.props.location?.state?.profileAlert || null;

    if (profileAlert) {
      this.setState({ profileAlert });
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: this.props.location.search,
      });
    }

    this.props
      .getAccountInfo()
      .finally(() => {
        this.setState({ isLoading: false, shouldAnimateCard: true });
        window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
      });
  }

  clearProfileAlert = () => {
    this.setState({ profileAlert: null });
  };

  renderField = (label, value) => (
    <div className="t-memberInfo-field">
      <span className="t-memberInfo-fieldLabel">{label}</span>
      <span className="t-memberInfo-fieldValue">{value || "-"}</span>
    </div>
  );

  renderEditableField = (label, value, linkTo) => (
    <div className="t-accountInfo-fieldRow">
      <div className="t-memberInfo-field t-accountInfo-fieldRow-content">
        <span className="t-memberInfo-fieldLabel">{label}</span>
        <span className="t-memberInfo-fieldValue">{value || "-"}</span>
      </div>
      <Link to={linkTo} className="t-memberInfo-btn t-memberInfo-btn--secondary t-accountInfo-fieldRow-action">
        Değiştir
      </Link>
    </div>
  );

  renderAccountLoading = () => (
    <EminevimLoading subtext="Profil bilgileriniz hazırlanıyor, lütfen bekleyiniz." />
  );

  render() {
    const { account } = this.props;
    const { isLoading, shouldAnimateCard, profileAlert } = this.state;
    const fullName = `${account?.adi || ""} ${account?.soyAdi || ""}`.trim();

    return (
      <div className="t-accountInfo-page" style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Profilim</h1>
              <p className="t-memberInfo-pageSubtitle">
                Kişisel ve iletişim bilgilerinizi görüntüleyin, gerekli alanları güncelleyin.
              </p>
            </div>

            {profileAlert ? (
              <LoginPageAlert
                messages={profileAlert.messages}
                type={profileAlert.type}
                onDismiss={this.clearProfileAlert}
              />
            ) : null}

            {isLoading ? (
              this.renderAccountLoading()
            ) : (
              <article
                className={`t-memberInfo-card t-memberDetail-header--green${
                  shouldAnimateCard ? " t-memberInfo-card--enter" : ""
                }`}
              >
                <div className="t-memberInfo-cardHeader">
                  <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                    <i className="t-icon-user1" aria-hidden="true" />
                  </div>

                  <div className="t-memberInfo-cardHeaderContent">
                    <h2 className="t-memberInfo-cardTitle">{fullName || "Profil Bilgilerim"}</h2>
                    <div className="t-memberInfo-cardBadges">
                      <span className="t-memberDetail-headerBadge">Üyelik Bilgilerim</span>
                    </div>
                  </div>
                </div>

                <div className="t-memberInfo-grid t-accountInfo-grid">
                  {this.renderField("Adı Soyadı", fullName)}
                  {this.renderField("Doğum Yeri", account?.dogumYeri)}
                  {this.renderField("TC Kimlik No", account?.vatandaslikNo)}
                  {this.renderEditableField(
                    "Mail Adresi",
                    account?.eposta,
                    "/Home/ControlContactInfo/Eposta"
                  )}
                  {this.renderEditableField(
                    "Cep Telefonu",
                    account?.cepTelefonu,
                    "/Home/ControlContactInfo/Gsm"
                  )}
                  <div className="t-accountInfo-fieldFull">
                    {this.renderField("Adres", account?.adres)}
                  </div>
                </div>
              </article>
            )}
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  account: selectAccountInfo(state),
});

const mapDispatchToProps = (dispatch) => ({
  getAccountInfo: () => dispatch(getAccountInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountInfo);
